    var page = 'developer-portal-container-view';
    export default [
        // { url: 'dev', params: { page: page, view: 'developer-portal-view' } },
        { url: 'dev/api/cpmm', params: { page: page, view: 'developer-documentation-view' } },
        { url: 'dev/api/cpmm/{link}', params: { page: page, view: 'developer-documentation-view' } },
    ];
